import CaretDownOutlined from '@ant-design/icons/CaretDownFilled';
import LineChartOutlined from '@ant-design/icons/LineChartOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import { ResetAnnotationOutlined } from '@vindr/icons';

import {
  AngleOutlined,
  AnnotateOutlined,
  BidirectionalOutlined,
  BookOutlined,
  BrightnessOutlined,
  Brush2Outlined,
  BrushOutlined,
  CadOutlined,
  CameraOutlined,
  CineOutlined,
  CircleBrushOutlined,
  CircleEraserOutlined,
  CouponOutlined,
  CropOutlined,
  CrossHairOutlined,
  CtrOutlined,
  Cube3DOutlined,
  CubeMprOutlined,
  DeleteOutlined,
  Download2Outlined,
  ElipseOutlined,
  FlipHorizontalOutlined,
  FlipVerticalOutlined,
  FreehandScalpelOutlined,
  InfoOutlined,
  InvertColorOutlined,
  LayoutOutlined,
  LengthToolOutlined,
  LensOutlined,
  LinkOutlined,
  MagnifyOutlined,
  PaintFillOutlined,
  PanToolOutlined,
  PickerOutlined,
  PointOutlined,
  PolygonOutlined,
  PrintOutlined,
  RectScalpelOutlined,
  RectangleOutlined,
  ReferenceLineOutlined,
  RefreshOutlined,
  RemoveBedOutlined,
  RemoveOutlined,
  Rotate3DOutlined,
  RotateRightOutlined,
  RulerOutlined,
  SettingsOutlined,
  ShuffleOutlined,
  SphereBrushOutlined,
  SphereEraserOutlined,
  SphereOutlined,
  StackOutlined,
  StraightenOutlined,
  TimelineOutlined,
  TuneOutlined,
  UsaOutlined,
  VietnamOutlined,
  ZoomInOutlined,
} from '@vindr/icons';
import type { AntdIconProps } from '@vindr/icons/src/components/AntdIcon';

const ICON_MAP = {
  'caret-down': CaretDownOutlined,
  'book': BookOutlined,
  'download': Download2Outlined,
  'icon-cad': CadOutlined,
  'icon-mpr': CubeMprOutlined,
  'icon-vr': Cube3DOutlined,
  'line-chart': LineChartOutlined,
  'link': LinkOutlined,
  'list-bullets': InfoOutlined,
  'tool-angle': AngleOutlined,
  'tool-annotate': AnnotateOutlined,
  'tool-bidirectional': BidirectionalOutlined,
  'tool-brush': BrushOutlined,
  'tool-calibration': RulerOutlined,
  'tool-ct-ratio': CtrOutlined,
  'tool-capture': CameraOutlined,
  'tool-circle': LensOutlined,
  'tool-circle-scissor': CouponOutlined,
  'tool-circle-brush': CircleBrushOutlined,
  'tool-circle-eraser': CircleEraserOutlined,
  'tool-cine': CineOutlined,
  'tool-cobb-angle': ShuffleOutlined,
  'tool-crosshair': CrossHairOutlined,
  'tool-delete': DeleteOutlined,
  'tool-elipse': ElipseOutlined,
  'tool-flip-horizontal': FlipHorizontalOutlined,
  'tool-flip-vertical': FlipVerticalOutlined,
  'tool-freehand-polygon': PolygonOutlined,
  'tool-freehand-line': TimelineOutlined,
  'tool-polyline': TimelineOutlined,
  'tool-invert': InvertColorOutlined,
  'tool-layout': LayoutOutlined,
  'tool-length': LengthToolOutlined,
  'tool-line': RemoveOutlined,
  'tool-magnify': MagnifyOutlined,
  'tool-move': PanToolOutlined,
  'tool-paint': PaintFillOutlined,
  'tool-point': PointOutlined,
  'tool-polygon': PolygonOutlined,
  'tool-presets': TuneOutlined,
  'tool-print': PrintOutlined,
  'tool-probe': PickerOutlined,
  'tool-rectangle': RectangleOutlined,
  'tool-rectangle-scissor': CropOutlined,
  'tool-referenceLines': ReferenceLineOutlined,
  'tool-reset': RefreshOutlined,
  'tool-reset-annotation': ResetAnnotationOutlined,
  'tool-rotate-right': RotateRightOutlined,
  'tool-sphere-scissor': SphereOutlined,
  'tool-sphere-brush': SphereBrushOutlined,
  'tool-sphere-eraser': SphereEraserOutlined,
  'tool-stack-scroll': StackOutlined,
  'tool-threshold-brush': Brush2Outlined,
  'tool-vr-rotate': Rotate3DOutlined,
  'tool-vr-freehand': FreehandScalpelOutlined,
  'tool-vr-rect': RectScalpelOutlined,
  'tool-vr-remove-bed': RemoveBedOutlined,
  'tool-vr-setting': SettingsOutlined,
  'tool-vr-distance': StraightenOutlined,
  'tool-window-level': BrightnessOutlined,
  'tool-patient-info': UserOutlined,
  'tool-zoom': ZoomInOutlined,
  'en-US': UsaOutlined,
  'vi': VietnamOutlined,
};

type IconName = keyof typeof ICON_MAP;

interface IIconProps extends AntdIconProps {
  readonly name: IconName;
  readonly color?: string;
}

export const Icon = ({ name, color = 'white', ...rest }: IIconProps): JSX.Element => {
  const Component = ICON_MAP[name];
  return Component ? <Component style={{ fill: color }} {...rest} /> : <></>;
};

export default Icon;
